import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from "@angular/core";
import {
    IAnalysisPackage,
} from "@irb/irb-editors/rebalance/irb-rebalance.model";


@Component({
    selector: "irb-generate-invest-cash-rebalance-settings",
    templateUrl: "./generate-invest-cash-rebalance-settings.component.html",
    styleUrls: ["./generate-invest-cash-rebalance-settings.component.scss"],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class GenerateInvestCashRebalanceSettingsComponent implements OnInit {
    @Output() change = new EventEmitter<any>();
    @Input() isReadOnly: boolean;

    analysisPackage: IAnalysisPackage;

    investCashSetting: string = "Securities";
    isUiTest = false;

    constructor() {
    }

    ngOnInit(): void {
      this.investCashSetting = this.data?.investCashSetting ?? this.investCashSetting;
    }

    @Input()
    get data() {
        return this.analysisPackage;
    }

    set data(data: IAnalysisPackage) {
        this.analysisPackage = data;
    }

    onCashChange() {
        this.data.investCashSetting = this.investCashSetting;
        this.change.emit(this.data);
    }
}

